import React from "react";

// Import your images
import Movie1 from "../assets/images/movie1.png";
import Movie2 from "../assets/images/movie2.png";
import Movie4 from "../assets/images/movie4.png";
import strangerThings from "../assets/images/strangerthings.png";
import Show1 from "../assets/images/show1.png";
import Show2 from "../assets/images/show2.png";
import Show3 from "../assets/images/show3.png";


export default function FavoriteMedia() {
  const favorites = [
    { title: "Lilo & Stitch", img: Movie1 },
    { title: "Wicked", img: Movie2},
    { title: "Zombies", img: Movie4},
    { title: "Stranger Things", img: strangerThings},
    { title: "Wizards Beyond Waverly Place", img: Show1 },
    { title: "Vampirina", img: Show2 },
    { title: "Phineas and Ferb", img: Show3 },
  ];

  return (
   <section className="pt-16 px-6 pb-20 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold text-yellow-700 text-center mb-4">
        Millie’s Favorite Movies & Shows
      </h2>

      <p className="text-center text-gray-700 max-w-2xl mx-auto mb-8">
        A peek at Millie’s most-loved movies and TV shows!
      </p>

      {/* FIXED Horizontal Scroll */}
      <div className="flex space-x-4 overflow-x-auto pb-4 px-1 snap-x snap-mandatory scrollbar-thin scrollbar-thumb-yellow-600 scrollbar-track-gray-200">
        {favorites.map((item, index) => (
          <div
            key={index}
            className="snap-start w-36 flex-shrink-0 text-center"
          >
            <img
              src={item.img}
              alt={item.title}
              className="w-40 h-64 object-cover rounded-2xl shadow-md mb-2"
              loading="lazy"
              />
            <p className="text-base font-medium text-gray-800 mt-1 text-center line-clamp-2">
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
